import { Component, inject } from '@angular/core';
import {VwuiModalRef} from '@recognizebv/vwui-angular';

@Component({
    standalone: false,
    selector: 'app-publish-quick-scan-version-modal',
    templateUrl: './publish-quick-scan-version-modal.component.html'
})
export class PublishQuickScanVersionModalComponent {
    modalRef = inject(VwuiModalRef);


    public loading = false;

    async submit() {
        this.modalRef.close(true);
    }

}
